import { isMobileScreenSize, isTabletScreenSize } from "constants/Responsibility";
import { useEffect, useState } from "react";
import useWindowDimensions from "./useWindowDimensions";

export const useDeviceSize = () => {
  const windowDimension = useWindowDimensions();

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileScreenSize(windowDimension.width));
    setIsTablet(isTabletScreenSize(windowDimension.width));
  }, [windowDimension.width]);

  return {
    isMobile, 
    isTablet,
  };
};